import React, { JSX, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles/navigation.css";
import { FaTimes, FaBars } from "react-icons/fa";

function Navigation(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  const location = useLocation();
  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  return (
    <nav
      className={isOpen ? "navigation open" : "navigation"}
      data-testid="navigation"
    >
      <div className="logo">
        <Link to="/" aria-label="VeeZeePee Farms home"></Link>
      </div>
      <ul id="primary-navigation" className={isOpen ? "menu open" : "menu"}>
        <li>
          <Link
            to="/"
            className={isActive("/") ? "active" : ""}
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/about-the-farm"
            className={isActive("/about-the-farm") ? "active" : ""}
            onClick={() => setIsOpen(false)}
          >
            About The Farm
          </Link>
        </li>
        <li>
          <Link
            to="/products"
            className={isActive("/products") ? "active" : ""}
            onClick={() => setIsOpen(false)}
          >
            Farm Products
          </Link>
        </li>
        <li>
          <Link
            to="/contacts"
            className={isActive("/contacts") ? "active" : ""}
            onClick={() => setIsOpen(false)}
          >
            Contact Us
          </Link>
        </li>
      </ul>
      <button
        className="menu-toggle"
        type="button"
        onClick={toggleMenu}
        aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isOpen}
        aria-controls="primary-navigation"
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>
    </nav>
  );
}

export default Navigation;
